import { FunctionComponent } from "react";
import { NEATTData } from "src/utils/types/UserTypes";


interface IFinancialHistoryDisplayProps {
    financialHistory: NEATTData['fh']
}

const FinancialHistoryDisplay: FunctionComponent<IFinancialHistoryDisplayProps> = ({ financialHistory }) => (
    <div className="w-full">
        <p className="mb-3"><span className="font-medium">Applied for Loan:</span> {financialHistory.appliedForLoan.applied}</p>
        <p className="mb-3"><span className="font-medium">Denied for Loan:</span> {financialHistory.appliedForLoan.denied}</p>
        <p className="mb-3"><span className="font-medium">Aware of Credit Score:</span> {financialHistory.awareOfCreditScore}</p>
        <p className="mb-3"><span className="font-medium">Behind on Payments:</span> {financialHistory.behindOnPayments}</p>
        <p className="mb-3"><span className="font-medium">Checked Credit in Last Year:</span> {financialHistory.checkedCreditInLastYear}</p>
        <p className="mb-3"><span className="font-medium">Has Cosigned for Others:</span> {financialHistory.cosignerOrGuaranteeForOther}</p>
        <p className="mb-3"><span className="font-medium">Has been Cosigned For:</span> {financialHistory.cosignerOrGuaranteeForClient}</p>
        <p className="mb-3"><span className="font-medium">Placed Block on Credit Report:</span> {financialHistory.placedBlockOnCredit}</p>
        <p className="mb-3"><span className="font-medium">Student Loan Debt:</span> {financialHistory.studentLoanDebt}</p>
        <p className="mb-3"><span className="font-medium">Utilizing 30% of Credit:</span> {financialHistory.using30Percent}</p>
        <p className="mb-3"><span className="font-medium">Unable to Payback:</span> {financialHistory.unableToPay.foreclosureOrDefault}</p>
        {financialHistory.unableToPay.foreclosureOrDefault === 'yes' && (<p className="mb-3"><span className="font-medium">Reason:</span> {financialHistory.unableToPay.reason}</p>)}
    </div>
);

export default FinancialHistoryDisplay;